import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export type ThemeMode = 'light' | 'dark';

type ThemeState = {
  themeMode:ThemeMode;
};

export const themeInitialState: ThemeState = {
  themeMode: 'light',
};

const themeSlice = createSlice({
  name: 'theme',
  initialState:themeInitialState,
  reducers: {
    setDarkMode(state, action: PayloadAction<ThemeMode>) {
      state.themeMode = action.payload;
    },
  },
});

export const { setDarkMode } = themeSlice.actions;
export default themeSlice.reducer;
